module.exports = __webpack_public_path__ + "static/img/flow.5796fec6.png";